<lex-action-panel>
    <div action-title>Compare</div>
    <div action-body>
      <div style="    display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      align-content: center;
      justify-content: center;
      height: 150px; gap: 20px;">
          <lex-flat-button label="SET COMPARE DOC" [icon]="'fa-duotone fa-check-double'" (click)="setCompareDoc()" style="width: 275px;"></lex-flat-button>
          <lex-flat-button label="CLEAR COMPARE DOC" [icon]="'fa-duotone fa-xmark single-color-icon'" (click)="clearCompareDoc()" style="width: 275px;">CLEAR COMPARE DOC</lex-flat-button>
    </div>
    </div>
  </lex-action-panel>
